import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { CSEService } from '../../services/cse.service';
import { NotificationService } from '../../services/notification.service';
import { UtilService } from '../../services/util.service';
import {
    TenderMaintenance
} from '../../models/models';

@Component({
    selector: 'tender-maintenance-form',
    templateUrl: './tender-maintenance-form.component.html',
    standalone: false
})
export class TenderMaintenanceForm implements OnChanges {
    @Input() tableID: number = 1;
    @Output() onRefresh = new EventEmitter<any>();

    public tableItem: TenderMaintenance = {} as TenderMaintenance;

    constructor(private cseService: CSEService, private notificationService: NotificationService, private utilService: UtilService) {
        this.getTableItem();
    }

    ngOnChanges() {
        //this.getTableItem();
        //console.log("ngOnChanges", this.tableID, this.carrierID);
    }

    private getTableItem() {
        if (this.tableID > 0) {
            this.cseService.getTenderMaintenanceByID(this.tableID).subscribe(result => {
                if (result.resultCollection.length > 0) {
                    this.tableItem = result.resultCollection[0];
                }
            });
        }
        else {
            //var employeeID = parseInt(localStorage.getItem('EmployeeId')!);
            this.tableItem = {
                tenderMaintenanceId: 0,
                hoursBeforePickup: 0,
                minutesBetweenTenderEmails: 0,
                tenderEmailSubject: "",
                tenderEmailBody: "",
                minutesBetweenInfoEmails: 0,
                infoEmailSubject: "",
                infoEmailBody: "",
                disclaimer: "",
                headerText: "",
                ccEmailList: ""
            };
        }
    }

    public save() {
        this.utilService.isLoading = true;
        console.log("save", this.tableItem);
        this.cseService.saveTenderMaintenance(this.tableItem).subscribe(result => {
            this.utilService.isLoading = false;
            if (result.resultCollection.length > 0) {
                this.notificationService.showSuccess("Tender Maintenance saved.", "SUCCESS: Tender Maintenance Save");
                this.onRefresh.emit();
            } else {
                this.notificationService.showError("Failed to save record.", "ERROR: Failed to Save");
                this.onRefresh.emit();
            }
        });

        //this.tableItem = {} as TenderMaintenance;
    }

    public cancel() {
        this.onRefresh.emit();
    }
}